<app-card-container [selected]="selecionado()" [showCheck]="selecionado()" [hoverEfect]="true" class="block h-full">
    <div class="cartao-corpo">
        <!-- Mesmo selo da coluna "Tipo" na tabela. A classe `tab-chip` é do escopo do CustomTable e
             não alcança conteúdo escrito aqui, então a forma vem do mixin comum. -->
        <span [class]="'cartao-chip cartao-chip--' + linha().tipoSolicitacaoTag.severity">{{ linha().tipoSolicitacaoTag.value || '-' }}</span>

        <app-identificacao-pessoa
            [foto]="linha().medicoPerfil.foto ?? null"
            [iniciais]="linha().medicoPerfil.iniciais ?? null"
            [nome]="linha().medicoPerfil.nome || 'Não informado'"
            [protocolo]="linha().idSolicitacaoStr"
            [inscricao]="linha().crmUfChip"
        />

        <div class="cartao-divisor" aria-hidden="true"></div>

        <app-detalhe-grid>
            <app-detalhe-item icone="pi pi-calendar" rotulo="Solicitação e validade">
                <app-vigencia-solicitacao [solicitacao]="linha().dataSolicitacaoStr" [validade]="linha().dataValidadeTag.value" [severidade]="linha().dataValidadeTag.severity" />
            </app-detalhe-item>

            <app-detalhe-item icone="pi pi-id-card" rotulo="CPF">
                <span class="cartao-maquina">{{ linha().cpf || '-' }}</span>
            </app-detalhe-item>

            <!-- Mesmo bloco da coluna de UF na tabela: bandeira do estado antes da sigla. -->
            <app-detalhe-item icone="pi pi-map-marker" [rotulo]="rotuloUf()">
                <app-bandeira-uf [uf]="valorUf()" />
            </app-detalhe-item>

            <app-detalhe-item icone="pi pi-info-circle" rotulo="Situação">{{ linha().statusStr || '-' }}</app-detalhe-item>
        </app-detalhe-grid>
    </div>
</app-card-container>
